

var ReferenceFieldCtrl = function($scope, $parse, $uibModal, $injector) {

	var self = this;
	this.createMode = !$scope.object.__vid;
	
	this.dictInitialized = false;
	this.filter_depends = function(object) {
		var klass = object.getClass();
		return klass.getObjectPayload(object, 'essential');
	}
	
	this.make_title = function(object) {
		var field = $scope.field;
		if (field.client && field.client.title) {
			var title_expr = field.client.title;
			var title = $parse(field.client.title);
			return title(object, window);
		} else {
			return object? object.__title : null;
		}
	}

	this.items = [];
	this.groups = [];

	this.update_dict = function() {
		return $scope.object.getClass()[$scope.field.name + '__dict']({
			//filter:Module.getFilterForContextField(fieldname)($scope.field.name),
			filter:{},
			data: self.filter_depends($scope.object)
		}).then(function(dict){
			var empty = {__title:'-- wybierz --', __vid:null};
			self.items = [];  // [empty]
			[].push.apply(self.items, dict);
			// kasuj niesutniejace (tylko bez effective_time)
			var found = false;
			if ($scope.object[$scope.field.name] && $scope.object[$scope.field.name].__vid && $scope.object[$scope.field.name].__vid.search(':') == -1) {
				for (var i=0; i<self.items.length; i++) {
					if ($scope.object[$scope.field.name].__id == self.items[i].__id) found = true;
				}
				if (!found) {
					$scope.object[$scope.field.name] = null;  //empty;
				}
			}
			
			// groupping
			if ($scope.field.parent_object) {
				self.groups = [];
				self.selected_group = $scope.$eval($scope.field.parent_object, $scope.object[$scope.field.name]);
				console.log('selected group', $scope.selected_group, $scope.object);
				self.orig_dict = [];
				self.orig_dict.push.apply(self.orig_dict, self.items);
				var seen_vids = [];
				for (var i=0; i<self.items.length; i++) {
					var parent = $scope.$eval($scope.field.parent_object, self.items[i]);
					if (!parent || !parent.__vid) continue;
					if (seen_vids.indexOf(parent.__vid) == -1) {
						self.groups.push(parent);
						seen_vids.push(parent.__vid);
					}
				}
				if (self.selected_group && seen_vids.indexOf(self.selected_group.__vid) == -1) self.selected_group = null;
			}
			
			self.dictInitialized = true;
		});
	}
	
	this.set_default = function() {
		// ustaw default
		if ($scope.object && $scope.object[$scope.field.name] && typeof $scope.object[$scope.field.name].__title != "undefined") return;
		if (self.items.length == 1) {
			$scope.object[$scope.field.name] = self.items[0];
		}
	}
	
	if ($scope.field.depends) {
		var depends = $parse($scope.field.depends);
		var getDepends = function() {
			var ret = depends($scope.object);
			if (!ret) return [null];
			return ret.__class? [ret.__id] : (ret.length? ret : [ret]);
		}
		$scope.$watchCollection(getDepends, function(x){
			if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
			if (self.dictInitialized) self.update_dict().then(self.set_default);
		});
	}
	
	$scope.$watch('object.effective_time', function(ef_time){
		console.log('reference-filter-reload', self.createMode);
		if ((!$scope.object || !$scope.object.id) && !self.createMode) return;
		if (self.dictInitialized) {
			self.update_dict().then(function(){
				if (self.createMode) self.set_default();
			});
		}
	}, true);

	if ($scope.field.parent_object) {
		$scope.$watch(function(){return self.selected_group}, function(selected){
			console.log('Changed combo group', selected);
			if (!selected) {
				self.items = angular.copy(self.orig_dict);
			} else {
				self.items.length = 0;
				var found = false;
				for (var i=0; i<self.orig_dict.length; i++) {
					var parent = $scope.$eval($scope.field.parent_object, self.orig_dict[i]);
					if (parent && parent.__vid == selected.__vid) {
						self.items.push(self.orig_dict[i]);
						if ($scope.object[$scope.field.name] && $scope.object[$scope.field.name].__vid == self.orig_dict[i].__vid) found = true;
					}
				}
				if (!found) $scope.object[$scope.field.name] = null;  //empty;
			}
		});
	}
	
	this.update_dict();


	// Creating new objects

	this.append_new = function(data) {
		if ($scope.field.client && $scope.field.client.type == 'image') {
			data['download'] = [{href: data.data, thumb: data.data}]
			$scope.object[$scope.field.name] = data;
			this.items.push(data);
		}
	}

	this.imageSelectDialog = function() {
		var classname = $scope.field.join.foreignClass;
		if ($injector.has('ContextService')) {
			var module = $injector.get('ContextService').getContext(classname);
		} else {
			var module = null;
		}
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'partials/fields/field-edit-reference-images.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'lg',
		      resolve: {
		        params: function ($q) {
		          return $q.all({
		          	data: {
						items: self.items, 
						selected: $scope.object[$scope.field.name],
						moduleName: module.getName(), 
						imageMode: ($scope.field.client && $scope.field.client.imagemode)? $scope.field.client.imagemode : 'cover',  // contain
					},
		          	submit:function(data) {
						$scope.object[$scope.field.name] = data.selected;
						return $q.resolve(data.selected);
					},
		          });
		        }
		      }
		});
	}

	window.rCtrl = this;

}



angular.module('forms.fields.reference', [])
.controller('ReferenceFieldCtrl', ReferenceFieldCtrl);